
import Layout from "../components/Layout";
import { Mensajecobranza } from "../components/mensajesCobranza";

const MensajesCobranza = () => {
	return (
		<>      
		<Layout/>
		<Mensajecobranza/>
		</>
	);
}

export default MensajesCobranza;   